import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { PageType, BetOutcomeOddDifference, TreeLevel, EventMappingType, SBVDisplayType, EventType, SpecialOfferType } from 'src/app/models/enums';
import { EventVM } from 'src/app/models/event/event';
import { IBetTypeSelection } from 'src/app/models/betType/betTypeSelection.interface';
import { ISportRegionCompetitionSelection } from 'src/app/models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { Subscription } from 'rxjs';
import { EventsService } from 'src/app/services/events.service';
import { SportsService } from 'src/app/services/sports.service';
import { TicketService } from 'src/app/services/ticket.service';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { ChangesUpdaterService } from 'src/app/services/changesUpdaterService.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { IBet } from 'src/app/models/bet/bet';
import { IBetOutcome } from 'src/app/models/bet/betOutcome.interface';
import { ITicketItemIdentifier } from 'src/app/models/ticket/ticketItemIdentfier.interface';
import { ICacheChanges } from 'src/app/models/cacheChanges/cacheChanges.interface';
import { ISport } from 'src/app/models/sportHierarchy/sport';
import { ScrollService } from 'src/app/services/scroll.service';
import { LoaderService } from 'src/app/services/loader.service';
import { blinkBorderAnimation } from 'src/app/animations/blink';
import { LocaleHelper } from 'src/locale/LocaleHelper';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ISrcSelectionIds } from 'src/app/models/util/srcSelectionIds.interface';
import { CacheService } from 'src/app/services/cache.service';

@Component({
  selector: 'app-special-events-mobile',
  templateUrl: './special-events-mobile.component.html',
  styleUrls: ['./special-events-mobile.component.less'],
  animations: [blinkBorderAnimation]
})
export class SpecialEventsMobileComponent implements OnInit, OnDestroy {

  arr = Array;
  dateTest = new Date();
  public sports: ISport[] = [];
  public eventsForSelectedSport: { [sportId: number]: EventVM[] } = {};
  public selectionsForSelectedSport: { [sportId: number]: IBetTypeSelection[] } = {};
  public sbvDisplayTypeEnum = SBVDisplayType;
  public pageTypeEnum = PageType;
  public selectedSportId: number;

  private selectionsDictionary: { [sportId: number]: { [betTypeId: number]: IBetTypeSelection } };
  public pageType: PageType = PageType.Prematch;
  private events: { [id: number]: EventVM } = {};
  private language: string;
  public languageForBetradar: string;

  betOutcomeOddDifferenceEnum = BetOutcomeOddDifference;

  protected sportRegionCompetitionSelection: ISportRegionCompetitionSelection;

  eventsMappingTypeEnum = EventMappingType;
  specialOfferTypeEnum = SpecialOfferType;
  eventTypeEnum = EventType;

  dynamicTranslations = DynamicTranslations;

  @Input()
  specialOfferType: SpecialOfferType;

  private ticketItemAddedRemovedSubscription: Subscription;
  private cacheChangesSubscription: Subscription;
  private pageTypeChangedSubscription: Subscription;

  constructor(
    private eventsService: EventsService,
    private sportsService: SportsService,
    private ticketService: TicketService,
    private cacheChangesService: CacheChangesService,
    private cache: CacheService,
    private changesUpdater: ChangesUpdaterService,
    private utilityService: UtilityService,
    private storage: StorageService,
    private scrollService: ScrollService,
    private loaderService: LoaderService,
    private queryParamService: QueryParamsService) {


    this.pageTypeChangedSubscription = this.queryParamService.pageTypeChanged$.subscribe((pt) => {
      this.pageType = pt;
    });
    this.ticketItemAddedRemovedSubscription = this.ticketService.ticketItemAddedRemoved$.subscribe((identifier) => {
      this.selectBetOutcomeFromTicket(identifier);
    });


    this.cacheChangesSubscription = this.cacheChangesService.cacheUpdatedPM$.subscribe((c) => this.updateEventsChanges(c));

    this.language = storage.language;
    this.languageForBetradar = LocaleHelper.languageForBetradar[this.language];
  }

  ngOnInit(): void {
    this.pageType = this.queryParamService.pageType;
    this.clearData();
    if (this.pageType === PageType.Prematch) {
      this.getSportsWithEventsAndSelections();
    } else {
      this.getMostPopularSports();
    }
  }

  private clearData() {
    this.events = {};
    this.selectionsDictionary = {};
    this.eventsForSelectedSport = [];
    this.selectionsForSelectedSport = [];
  }

  getSportName(sportId: number): string {
    return this.utilityService.getSportIcon(sportId);
  }


  selectSport(sportId: number) {
    if (sportId === this.selectedSportId) {
      this.selectedSportId = null;
      return;
    }
    this.selectedSportId = sportId;
    if (this.pageType === PageType.Prematch) {
      this.setEventsAndSelectionsForSelectedSport(sportId);
    } else {
      this.events = {};
      this.eventsForSelectedSport = [];
      this.getMostPopularEvents(sportId);
    }
  }

  showDetail(event: EventVM) {
    this.eventsService.expandEvent(event);

    if (event.isExpanded) {
      this.scrollService.expandEventLiveChange(true);
    } else {
      this.scrollService.expandEventLiveChange(false);
    }
  }

  public getSportsWithEventsAndSelections() {
    const dates = this.utilityService.getDateFromTo(false, this.sportsService.timeFilterValueGet);
    this.eventsService.getSpecialOfferEventsMobile(this.specialOfferType, dates.dateFrom, dates.dateTo).subscribe(x => {
      this.selectionsDictionary = x.selections;
      this.events = x.events;
      this.sports = x.sports;
      for (const [k, ev] of Object.entries(this.events)) {
        this.cacheChangesService.subscribeForCompetitionChanges(ev.competitionId, false);
      }

      this.setEventsAndSelectionsForAllSports();
    });
  }

  private getMostPopularSports() {
    this.sportsService.getMostPopularSports(10).subscribe((sports) => {
      this.sports = sports;
    });
  }

  private getMostPopularEvents(sportId: number) {
    this.eventsService.getMostPopularEventsMobile(sportId).subscribe(x => {
      this.selectionsDictionary[sportId] = x.selections;
      this.events = x.events;
      this.setEventsAndSelectionsForSelectedSport(sportId);
    });
  }

  private setEventsAndSelectionsForSelectedSport(sportId: number) {
    if (sportId) {
      if (this.eventsForSelectedSport[sportId]) {
        this.eventsForSelectedSport[sportId] = [];
      }
      if (this.selectionsForSelectedSport[sportId]) {
        this.selectionsForSelectedSport[sportId] = [];
      }
      if (!this.events || Object.keys(this.events).length === 0) {
        return;
      }
      this.eventsForSelectedSport[sportId] = this.pageType === PageType.MostPopular ? this.utilityService.sortByOrderNo(Object.entries(this.events).map(([k, ev]) => ev)) : this.utilityService.sortEventsByDateAndCode(Object.entries(this.events).map(([k, ev]) => ev).filter(ev => ev.sportId === sportId));

      this.selectionsForSelectedSport[sportId] = this.selectionsDictionary[sportId] ? Object.entries(this.selectionsDictionary[sportId]).map(([k, v]) => v) : [];
    } else {


    }
  }

  private setEventsAndSelectionsForAllSports() {
    this.eventsForSelectedSport = {};
    this.selectionsForSelectedSport = {};

    for (const sport of this.sports) {
      this.setEventsAndSelectionsForSelectedSport(sport.id);
    }

  }

  toggleEventOutcome(event: EventVM, bet: IBet, outcome: IBetOutcome, betTypeOutcomeName: string, betTypeName: string) {
    if (!((event.isPlayable && bet.isPlayable && outcome.isPlayable) || outcome.isSelected)) {
      return;
    }
    this.ticketService.toggleEventOutcome(event, bet, outcome, betTypeOutcomeName, betTypeName);
  }

  selectBetOutcomeFromTicket(identifier: ITicketItemIdentifier) {
    this.utilityService.selectBetOutcomeFromEvents(this.events, identifier);
  }

  updateEventsChanges(cacheChanges: ICacheChanges) {
    const updateEventsResponse: { eventAddedRemoved: boolean; srcToDecrement: ISrcSelectionIds[] } = this.changesUpdater.updateEventsChanges(this.events, cacheChanges, this.selectionsDictionary, true, false, this.specialOfferType);
    const eventAddedRemoved: boolean = updateEventsResponse.eventAddedRemoved;
    this.changesUpdater.updateBetChangesNonExpandedEvents(this.events, cacheChanges, this.selectionsDictionary, false, TreeLevel.Sports);
    this.changesUpdater.updateOutcomeChangesNonExpandedEvents(this.events, cacheChanges, this.selectionsDictionary, false, TreeLevel.Sports);
    if (eventAddedRemoved) {
      if (this.pageType === PageType.Prematch) {
        if (this.selectedSportId) {
          const allEventslist = Object.entries(this.events).map(([k, ev]) => ev);
          for (const sport of this.sports) {
            sport.eventsCount = allEventslist.filter(ev => ev.sportId === this.selectedSportId).length;
            if (sport.id === this.selectedSportId && sport.eventsCount === 0) {
              this.selectedSportId = null;
            }
          }
          if (this.selectedSportId) {
             this.eventsForSelectedSport[this.selectedSportId] = allEventslist.filter(ev => ev.sportId === this.selectedSportId);
          }
        } else {
          this.setEventsAndSelectionsForAllSports();
        }

      } else {
        if (this.selectedSportId) {
          this.getMostPopularEvents(this.selectedSportId);
        }
      }
    }
    if (updateEventsResponse.srcToDecrement.length > 0) {
      this.cache.decrementSrcs(updateEventsResponse.srcToDecrement);
    }
  }



  ngOnDestroy() {
    this.ticketItemAddedRemovedSubscription.unsubscribe();
    this.cacheChangesService.removeCompetitionsSubscribtion(false);
    this.cacheChangesSubscription.unsubscribe();
    // this.clearViewSubscription.unsubscribe();
    this.pageTypeChangedSubscription.unsubscribe();
  }

}
